import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MessageService } from 'primeng/api';

@Component({ standalone: false,
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',

  styleUrls: ['./file-upload.component.css']
})
export class FileUploadComponent {
    @Input() form: FormGroup;
    @Input() formLabelPhoto: string;
    @Input() disabled: boolean;
    @Input() width: string;
    @Input() height: string;
    @Input() label: string;
    @Input() type: string;
    @Input() accept: string;

    isDragging = false;

    fileName: string = '';
    fileSize: number = 0;

    constructor(private messageService: MessageService) {}

    ngOnInit(){
        if(this.formLabelPhoto){
            const archivoBase64 = this.form.get(this.formLabelPhoto)?.value;
            if (archivoBase64) {
              this.fileSize = this.getFileSize(archivoBase64);
              this.fileName = "terminos_y_condiciones.pdf";
            }
        }
    }

    getFileSize(base64String: string): number {
        let padding, inBytes, base64StringLength;
        if (base64String.endsWith('==')) padding = 2;
        else if (base64String.endsWith('=')) padding = 1;
        else padding = 0;

        base64StringLength = base64String.length;
        inBytes = (base64StringLength / 4) * 3 - padding;
        return parseFloat((inBytes / 1024).toFixed(2));
    }


    onFileSelected(event: Event) {
        const input = event.target as HTMLInputElement;

        if (input.files && input.files[0]) {
        const file = input.files[0];

        this.fileName = file.name;
        this.fileSize = parseFloat((file.size / 1024).toFixed(2));

        let fileSize = parseFloat((file.size / 1024).toFixed(2)); // Convert to KB
        if(fileSize > 250){
            this.messageService.add({key:'basic-message',severity:'error', summary: 'Validación de formulario', detail: 'El archivo excede el tamaño permitido de 250KB.'});
            return;
        }

        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = () => {
            const base64String = reader.result as string;
            this.form?.get(this.formLabelPhoto)?.patchValue(base64String);
        };

        reader.onerror = (error) => {
            console.error('Error al convertir el archivo a Base64:', error);
        };
        }
    }

    onDragOver(event: DragEvent) {
        event.preventDefault();
        this.isDragging = true;
    }

    onDragLeave(event: DragEvent) {
        event.preventDefault();
        this.isDragging = false;
    }

    onDrop(event: DragEvent) {
        if(this.disabled) return;

        event.preventDefault();
        this.isDragging = false;

        if (event.dataTransfer?.files && event.dataTransfer.files[0]) {
        const file = event.dataTransfer.files[0];
        this.fileName = file.name;
        this.fileSize = parseFloat((file.size / 1024).toFixed(2));

        let fileSize = parseFloat((file.size / 1024).toFixed(2)); // Convert to KB
        if(fileSize > 250){
            this.messageService.add({key:'basic-message',severity:'error', summary: 'Validación de formulario', detail: 'El archivo excede el tamaño permitido de 250KB.'});
            return;
        }

        this.convertFileToBase64(file);
        }
    }

    convertFileToBase64(file: File) {
        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = () => {
        const base64String = reader.result as string;
        this.form?.get(this.formLabelPhoto)?.patchValue(base64String);
        };

        reader.onerror = (error) => {
        console.error('Error al convertir el archivo a Base64:', error);
        };
    }

    clearDocument(event: any){
        this.form?.get(this.formLabelPhoto)?.patchValue(null);
        event.stopPropagation();
    }

    triggerFileInputClick(){
        const fileInput = document.getElementById(this.formLabelPhoto) as HTMLInputElement;
        if (fileInput) {
        fileInput.click();
        } else {
        console.error('No se encontró el input de archivo con id:', this.formLabelPhoto);
        }
    }
}
